import { failure, initial, pending, remoteData, success } from '@devexperts/remote-data-ts';
import { array } from 'fp-ts/lib/Array';
import { fromEquals } from 'fp-ts/lib/Setoid';
import { sequence } from 'fp-ts/lib/Traversable';
import { of, pipe } from 'rxjs';
import { delay, filter, map, shareReplay, startWith, switchMap, tap } from 'rxjs/operators';
export function isNotNull(value) {
    return value !== null;
}
export function isDefined(value) {
    return value !== null && typeof value !== 'undefined';
}
/**
 * Turn RemoteData<A>[] into RemoteData<A[]>
 */
export var combineRemoteData = sequence(remoteData, array);
export function switchMapRD(fn) {
    return switchMap(function (dataRD) {
        return dataRD.fold(of(initial), of(pending), function (e) { return of(failure(e)); }, function (success) { return fn(success); });
    });
}
export function mapRD(fn) {
    return map(function (dataRD) { return dataRD.map(fn); });
}
export function tapRD(fn) {
    return tap(function (dataRD) { return dataRD.map(fn); });
}
export function logRX(rx, tag) {
    // tslint:disable-next-line: no-console
    return rx.pipe(tap(function (v) { return console.log('[logRX' + (tag ? ":" + tag : '') + ']', v); }));
}
export function filterRD(predicate) {
    return filter(function (remoteData) {
        return !remoteData.isSuccess() || predicate(remoteData.value);
    });
}
export var filterSuccess = pipe(filter(function (rd) { return rd.isSuccess(); }), map(function (rd) { return rd.value; }));
var REMOTE_DATA_TAGS = ['RemoteInitial', 'RemotePending', 'RemoteFailure', 'RemoteSuccess'];
export function isRemoteData(data) {
    return data._tag && REMOTE_DATA_TAGS.includes(data._tag);
}
export function getRightSetoid(setoid) {
    return {
        equals: function (a, b) {
            return a.fold(b.isInitial(), b.isPending(), function (err) { return b.isFailure() && b.error === err; }, function (aVal) { return b.exists(function (b) { return setoid.equals(aVal, b); }); });
        },
    };
}
export function shouldShowResult(delayMs) {
    if (delayMs === void 0) { delayMs = 3000; }
    return switchMap(function (result) {
        if (result.isFailure() || result.isSuccess()) {
            return of(false).pipe(delay(delayMs), startWith(true));
        }
        else {
            return of(false);
        }
    });
}
export var promiseToRD = function (promise) {
    return promise.then(function (val) { return success(val); }, function (err) { return failure(err instanceof Error ? err : new Error("" + err)); });
};
export var nullableSetoid = function (delegate) {
    return fromEquals(function (a, b) { return (a === undefined ? b === undefined : b !== undefined && delegate.equals(a, b)); });
};
export var shareReplayRefCount = function (bufferSize) {
    if (bufferSize === void 0) { bufferSize = 1; }
    return shareReplay({ bufferSize: bufferSize, refCount: true });
};
export var validateRequired = function (val) { return (val && val.length ? null : 'Required'); };
export function isEnum(enumObj) {
    var values = Object.values(enumObj);
    return function (val) { return values.includes(val); };
}
//# sourceMappingURL=object.utils.js.map